import Card from "../../component/Card"
import SmallHeadingComponent from "../../component/SmallHeadingComponent"
import CenterContents from "../../component/CenterContents"
import SmallestHeadingComponent from "../../component/SmallestHeadingComponent"
import { useEffect, useState } from "react"
import {
    allMedicationCounterMeasures,
    DateAPI,
    MedicationGroupATCs,
    MedicationGroupNames,
    MedicationGroups
} from "pokal_api"
import TextField from "../../component/TextField"

function DeveloperUtilityView() {
    const [dateString, setDateString] = useState<string>("")
    const [timestampString, setTimestampString] = useState<number>(-1)

    useEffect(() => {
        try {
            setTimestampString(DateAPI.parseDate(dateString))
        } catch {
            setTimestampString(-1)
        }
    }, [dateString])

    return (
        <CenterContents>
            <div className={"max-w-[600px] w-full sm:mt-20 flex flex-col space-y-5"}>
                <Card width={"100%"}>
                    <div className={"flex flex-col space-y-4"}>
                        <SmallHeadingComponent>
                            Medikationsgruppen
                        </SmallHeadingComponent>
                        {Object.keys(MedicationGroupNames).map((k) => (
                            <div className={"flex w-full"}>
                                <div key={k}>
                                    {
                                        MedicationGroupNames[k as unknown as MedicationGroups]
                                    }
                                </div>
                                <div className={"ml-auto"}>{MedicationGroupATCs[k as unknown as MedicationGroups].length}</div>
                            </div>
                        ))}
                    </div>
                </Card>
                <Card width={"100%"}>
                    <div className={"flex flex-col space-y-8"}>
                        <SmallHeadingComponent>
                            Developer Utility
                        </SmallHeadingComponent>
                        <div className={"flex flex-col space-y-2"}>
                            <SmallestHeadingComponent>
                                Date Converter
                            </SmallestHeadingComponent>
                            <div>Converts DD.MM.YYYY to timestamp</div>
                            <div className={"flex space-x-4"}>
                                <div className={"flex-1"}>
                                    <TextField
                                        placeholder={"Insert DD.MM.YYYY"}
                                        type={"text"}
                                        width={"100%"}
                                        inputState={[dateString, setDateString]}
                                    />
                                </div>
                                <div className={"font-bold flex-1"}>
                                    Timestamp: {timestampString}
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </CenterContents>
    )
}

export default DeveloperUtilityView
